import { USER, URL } from '../constants/constant';
import { _axios } from '../plugins/axios';


export const sendLinkToCustomer = (applicationId) => {

  let data = {
    applicationId: applicationId.toString() + 'DIGIMER'
  }
  let config = {
    method: 'post',
    url: URL.REACT_VIDEO_MB,
    headers: {
      'Content-Type': 'application/json',
    },
    data: data
  }


  return _axios(config)
    .then((response) => {
      console.log(response)
      return response.status;
    })
    .catch((error) => {
      if (error.response) {
        let errorObj = {
          errorStatus: error.response.status,
          errorResponse: error.response
        }
        return errorObj
      }
    });
}

export const updateUploadFilesToAttachments = (data) => {
  let payload = {
    fileName: data.fileName,
    fileType: data.documentType,
    appId: 9194,
    fileIdentifier: data.fileIdentifier,
    updatedBy: USER?.user?.phleboId,
    vendor: data.vendor,
    applicationId: data.applicationId.toString() + 'DIGIMER'
  };
  let config = {
    method: 'post',
    url: URL.REACT_FUSER_URL + "api/v1/digitization/runnr/attachments/save",
    headers: {
      "accesstoken": USER.access_token,
      "Content-Type": "application/json"
    },
    data: payload
  }

  return _axios(config)
  .then((response) => {
    console.log(response);
    return response.data;

  })
  .catch((error) => {
    if (error.response) {
      let errorObj = {
        errorStatus: error.response.status,
        errorResponse: error.response
      }
      return errorObj
    }
  });
}

export const uploadFileUsingPresignedURL = (url,file,fileType) => {
  let config = {
    method: 'put',
    url: url,
    headers: {
      "accesstoken": USER.access_token,
      "Content-Type": fileType
    },
    data: file
  }

  return _axios(config)
    .then((response) => {
      console.log(response)
      return response.status;
    })
    .catch((error) => {
      if (error.response) {
        let errorObj = {
          errorStatus: error.response.status,
          errorResponse: error.response
        }
        return errorObj
      }
    });
}

export const getPresignedURL = (data) => {
  let payload = {
    s3AccountType: "DOCSAPP",
    fileName: data.fileName,
    fileType: data.fileType,
    appId: 9194,
    vendor: data.vendor,
    applicationId: data.applicationId.toString() + 'DIGIMER'
  };
  let config = {
    method: 'post',
    url: URL.REACT_FUSER_URL + "api/v1/transferToS3/get/SignedURL",
    headers: {
      "accesstoken": USER.access_token,
      "Content-Type": "application/json"
    },
    data: payload
  }
  return _axios(config)
    .then((response) => {
      console.log(response);
      return response.data;

    })
    .catch((error) => {
      if (error.response) {
        let errorObj = {
          errorStatus: error.response.status,
          errorResponse: error.response
        }
        return errorObj
      }
    });
}
